import { Map, LngLatBoundsLike, Layer } from 'mapbox-gl';

import { FeatureCollection, MultiPolygon, featureCollection } from '@turf/helpers';
import difference from '@turf/difference';
import bboxPolygon from '@turf/bbox-polygon';
import bbox from '@turf/bbox';

import { RemoveLayer } from './layer-remove.service';
import { projectDefaultColor } from '@/services/utils.service';

export const AddFilter = (
  map: Map,
  type: string,
  geoJsonPolygon: FeatureCollection<MultiPolygon>,
  state: { layer: Layer; type: string; subType?: string }[]
): void => {
  // get first polygon
  const [feature] = geoJsonPolygon.features;

  // reverse polygon
  const polygon = difference(
    // entire world
    bboxPolygon([-180, 90, 180, -90]),
    feature
  );

  if (!polygon) return;

  const data = featureCollection([polygon]);

  RemoveLayer(map, type);
  if (type === 'Filter') RemoveLayer(map, 'FilterLine');

  const layer: Layer = {
    id: type,
    type: 'fill',
    source: {
      data,
      type: 'geojson'
    },
    paint: {
      'fill-color': '#000',
      'fill-outline-color': projectDefaultColor(),
      'fill-antialias': true,
      'fill-opacity': 0.4
    }
  };
  state.push({ layer, type });
  map.addLayer(layer);
  if (type === 'Filter') {
    const layerLine: Layer = {
      id: 'FilterLine',
      type: 'line',
      source: {
        data,
        type: 'geojson'
      },
      paint: {
        'line-color': projectDefaultColor(),
        'line-width': 2
      },
      layout: {
        'line-cap': 'round',
        'line-join': 'round'
      }
    };
    state.push({ layer: layerLine, type: 'FilterLine' });
    map.addLayer(layerLine);
  }

  const [a, b, c, d] = bbox(geoJsonPolygon);

  const lngLatBounds: LngLatBoundsLike = [a, b, c, d];
  map.fitBounds(lngLatBounds, { padding: 50 });
};

export const AddLayer = (map: Map, layer: Layer): void => {
  RemoveLayer(map, layer.id);
  map.addLayer(layer);
};
